/* global mixpanel, ga */
import root from 'window-or-global';

let isProduction;
if (!root.location) {
  isProduction = false;
}
else {
  isProduction = root.location.host === 'www.instamojo.com';
}

if (!root.MojoUser) {
  root.MojoUser = {};
}

function eventTracker(category, action, label, value) {
  label = label || false;
  value = value || false;

  if(label && value) {
    ga('send', 'event', category, action, label, value);
  }
  else if (label) {
    ga('send', 'event', category, action, label);
  }
  else {
    ga('send', 'event', category, action);
  }
}

let queuedEvents = [];

const MixpanelAPI = {
  setUserProps: function (user, userProps = {}) {
    if(!user.delay_mixpanel_identify && user.id){
      mixpanel.identify(user.id);
    }

    const userAgentBotTest = navigator.userAgent;
    mixpanel.register({ 'user_agent': userAgentBotTest });
    if (/bot/i.test(userAgentBotTest)) {
      mixpanel.register({ '$ignore':'true' });
    }

    if (isProduction) {
      if (user && user.email && user.email.split('@')[1] === 'instamojo.com') {
        mixpanel.register({ '$ignore':'true' });
      }
    }

    if (user && user.username) {
      mixpanel.people.set({
        id: user.id,
        '$email': user.email,
        '$username': user.username,
        '$phone': user.phone,
        user_level: user.user_level,
        ...userProps,
      });
    }
  },

  sendEvent: function (eventName, eventData) {
    mixpanel.track(eventName, eventData);
  },

  setNewUsername: function (newUsername) {
    root.MojoUser.username = newUsername;
    mixpanel.register({ 'username': newUsername });
    mixpanel.people.set({ '$username': newUsername });
  },

  queueEvent: function (eventName, eventData) {
    queuedEvents.push({ eventName, eventData });
  },

  clearQueue: function () {
    queuedEvents.forEach(event => {
      const { eventName, eventData } = event;
      MixpanelAPI.sendEvent(eventName, eventData);
    });

    queuedEvents = [];
  },
};

function Analytics (provider) {
  provider = provider || 'mixpanel';	//flexibility to change provider later

  const providerApiMap = {
    'mixpanel': MixpanelAPI,
  };

  const tracker = providerApiMap[provider];

  typeof mixpanel !== 'undefined' ?  tracker.setUserProps(root.MojoUser) : null;

  return {
    sendEvent: function (eventName, eventData = {}, ga = false) {
      if (typeof eventName !== 'string') {
        throw Error('Expected first argument to be a string');
      }

      if (ga && isProduction) {
        eventTracker(eventData.category || eventName, eventData.action || '', eventData.label || false, eventData.value || false);
      }

      if ('onLine' in root && !root.onLine) {
        // assign the time at which event occurred.
        tracker.queueEvent(eventName, { ...eventData, offline: true, time: Math.floor(Date.now() / 1000) });
      }

      /* send the actual event */
      tracker.sendEvent(eventName, eventData);
    },

    clearQueuedEvents: () => {
      tracker.clearQueue();
    },
    setUserProps: (userProps) => { tracker.setUserProps(root.MojoUser, userProps); },
    setNewUsername: (newUsername) => { tracker.setNewUsername(newUsername); },
  };
}

const analytics = new Analytics();

export default analytics;



// WEBPACK FOOTER //
// ./src/common/config/Analytics.js